import React from "react";
import { useEffect, useState } from "react";
import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import axios from "axios";
import { BACKEND_URL } from "../../constants/urls";

import {
  Container,
  EquipmentContainer,
  Heading,
  HeadingsContiner,
  ConditionButton,
} from "./styled.components";
const Machinery = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/equipments`).then((res) => {
      console.log(res.data.equipments);
      setData(res.data.equipments);
    });
  }, []);

  return (
    <>
      <Layout>
        <Hero
          title="Machinery Equipments"
          SubTitle="HHH and Sons Presents a Proud Past And Will  Keep The Promise For Days To Come"
        />
        <Container>
          <HeadingsContiner>
            <Heading>Type/Model/Make</Heading>
            <Heading>Quantity</Heading>
            <Heading>Model</Heading>
            <Heading>Ownership</Heading>
            <Heading>Condition</Heading>
          </HeadingsContiner>
          {data.map((item) => (
            <>
              <EquipmentContainer>
                <Heading>{item.name}</Heading>
                <Heading>{item.quantity}</Heading>
                <Heading>{item.model}</Heading>
                <Heading>{item.ownership}</Heading>
                <ConditionButton>{item.status}</ConditionButton>
              </EquipmentContainer>
            </>
          ))}
        </Container>
      </Layout>
    </>
  );
};

export default Machinery;
